<template>
  <div class="seal-selector">
    <el-checkbox-group v-model="selected" :disabled="readonly" @change="onChange">
      <el-checkbox label="officialSeal">公章</el-checkbox>
      <el-checkbox label="contractSeal">合同章</el-checkbox>
      <el-checkbox label="legalSeal">法人章</el-checkbox>
      <el-checkbox label="managerSeal">总经理私章</el-checkbox>
      <el-checkbox label="partyComprehensiveSeal">党政综合部印章</el-checkbox>
      <el-checkbox label="financeSeal">财务专用章</el-checkbox>
      <el-checkbox label="invoiceSeal">发票专用章</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'SealSelector',
  props: {
    value: { default: null },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return { selected: [] }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val && typeof val === 'object') {
          this.selected = Object.keys(val).filter(k => val[k])
        } else if (Array.isArray(val)) {
          this.selected = val
        }
      }
    }
  },
  methods: {
    onChange(val) {
      const obj = {
        officialSeal: val.includes('officialSeal'),
        contractSeal: val.includes('contractSeal'),
        legalSeal: val.includes('legalSeal'),
        managerSeal: val.includes('managerSeal'),
        partyComprehensiveSeal: val.includes('partyComprehensiveSeal'),
        financeSeal: val.includes('financeSeal'),
        invoiceSeal: val.includes('invoiceSeal')
      }
      this.$emit('input', obj)
    }
  }
}
</script>

<style scoped>
.seal-selector { padding: 4px 0; }
</style>
